import {ILoadingState, TWithLoadingState} from 'plugins/loading/types';

export const initialLoadingState: ILoadingState = {
    isLoading: false,
};

export const withLoadingState = <T>(originState: T): TWithLoadingState<T> => {
    return {
        ...initialLoadingState,
        ...originState,
    };
};
